import { render, staticRenderFns } from "./orderSearchDetails.vue?vue&type=template&id=5e992895&scoped=true&"
import script from "./orderSearchDetails.vue?vue&type=script&lang=js&"
export * from "./orderSearchDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderSearchDetails.vue?vue&type=style&index=0&id=5e992895&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e992895",
  null
  
)

export default component.exports